<section class="categories-wrp pb-0 christmasTheme">
  <div class="container">
    <div class="categories-wrp-inner">

      <h4 class="heading-w-border mb-2 colorWhite">
        <span>Explore Moods</span>
      </h4>
      <p class="colorWhite">Pick what you feel like doing today</p>

      <div class="categories-slider categories-slider-2">

        <div uk-slider>
          <div class="uk-position-relative">
            <div class="uk-slider-container uk-light">
              <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-5@m uk-grid-small"
                  uk-grid>


                <li *ngFor="let category of categories.STANDARD" class="active">
                  <a [routerLink]="['/'+selectedCity.toLowerCase()+'/deals/'+category.slug]">
                    <div class="categores-card-2">
                      <div class="icons {{category.color_code}}">
                        <img src="{{category.category_image}}" alt="">
                      </div>
                      <p>{{category.category_name}}</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <!--uk-slider-container--->

            <a class="uk-position-center-left-out custom-nav hideMobile" href="#" uk-slidenav-previous
               uk-slider-item="previous">
              <img src="assets/images/icons/arrow-right.png" alt="">
            </a>
            <a class="uk-position-center-right-out custom-nav hideMobile" href="#" uk-slidenav-next
               uk-slider-item="next">
              <img src="assets/images/icons/arrow-right.png" alt="">
            </a>

          </div>
        </div>

      </div>
      <!--categories-slider--->
    </div>
  </div>
  <!--container--->
</section>

<!--Loader-->
<section class="categories-wrp pb-0" hidden>
  <div class="container">
    <div class="categories-wrp-inner">

      <h4 class="heading-w-border mb-2">
        <span>Explore Moods</span>
      </h4>
      <p>Pick what you feel like doing today</p>

      <div class="categories-slider categories-slider-2">

        <div uk-slider>
          <div class="uk-position-relative">
            <div class="uk-slider-container uk-light">
              <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-5@m uk-grid-small"
                  uk-grid>
                <li *ngFor="let category of [1,2,3,4,5]" class="active">
                  <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
                </li>
              </ul>
            </div>
            <!--uk-slider-container--->


          </div>
        </div>

      </div>
      <!--categories-slider--->
    </div>
  </div>
  <!--container--->
</section>
